import { render } from "./AdminTextsEdit.vue?vue&type=template&id=3070000e&scoped=true&bindings={\"id\":\"props\",\"lanExists\":\"options\",\"addTranslationBtnDisabled\":\"options\",\"isHTML\":\"options\",\"isText\":\"options\",\"isLabel\":\"options\",\"texts\":\"data\",\"addNewLanCode\":\"data\",\"wasValidated\":\"data\",\"getText\":\"options\",\"cancel\":\"options\",\"submit\":\"options\",\"postText\":\"options\",\"addNewTranslation\":\"options\",\"tinyOptions\":\"options\"}"
import script from "./AdminTextsEdit.vue?vue&type=script&lang=js"
export * from "./AdminTextsEdit.vue?vue&type=script&lang=js"

import "./AdminTextsEdit.vue?vue&type=style&index=0&id=3070000e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3070000e"

export default script